import { ProjectTokenInfo } from '~/api/repository'

export class SidebarTokenMenuModel {
  private readonly _label?: string
  private readonly _value?: string

  constructor (res: ProjectTokenInfo) {
    this._label = res.NM
    this._value = res.ID
  }

  get label () {
    return this._label
  }

  get value () {
    return this._value
  }
}